// The rules that need a scene's terrain and its edges together, twin of MapLibrary.settle: a mark on a diagonal
// needs a cut cell, and a cut cell whose two halves hold the same floor with no mark on its diagonal is a whole cell.
// Held to the "settle" cases of test/fixtures/files/map_terrain_cuts_vectors.json.
import { cutAt, terrainOf, terrainWrite } from "./cuts";
import { type Edges, normalizeEdges } from "./edges";
import { EMPTY } from "./terrain";

type Lines = readonly string[];
// `{}` is the empty terrain.
type Terrain = { rows?: Lines; cuts?: Lines; corners?: Lines; borders?: Lines };

const at = (lines: Lines | undefined, col: number, row: number) => lines?.[row]?.[col] ?? EMPTY;

export type Settled = { terrain: { rows?: string[]; cuts?: string[]; corners?: string[]; borders?: string[] }; edges: Edges };

export function settle(terrain: Terrain, edges: Edges): Settled {
	const { rows, cuts, corners, borders } = terrainOf(terrain.rows ?? [], terrain.cuts, terrain.corners, terrain.borders);
	const cut = (col: number, row: number) => cutAt(cuts, col, row) !== null && at(rows, col, row) !== EMPTY;
	const marks = (edges.d ?? []).map((line, row) => [...line].map((code, col) => (cut(col, row) ? code : EMPTY)).join(""));
	const whole = (col: number, row: number) => cut(col, row) && at(corners, col, row) === at(rows, col, row) && at(marks, col, row) === EMPTY;
	const drop = (lines: Lines | undefined) => lines?.map((line, row) => [...line].map((code, col) => (whole(col, row) ? EMPTY : code)).join(""));
	const settled = terrainOf(rows, drop(cuts), drop(corners), borders);
	return { terrain: settled.rows.length ? terrainWrite(settled) : {}, edges: normalizeEdges({ ...edges, d: marks }) as Edges };
}
